// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-a0a4","fixed":"fixed-a2ef","higherZindex":"higherZindex-dd78","roundCorners":"roundCorners-9c5c","dark":"dark-19e3","spinner-text":"spinner-text-5294"};